const formatUnitsK = 1000;
const formatUnitsSizes = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
export const formatUnits = (value: number, unit='', decimals=1) => {
  if (!+value) return `0 ${unit}`;

  const dm = decimals < 0 ? 0 : decimals;
  const sizes = formatUnitsSizes.map((size) => `${size}${unit}`);

  const i = Math.floor(Math.log(value) / Math.log(formatUnitsK));
  return `${parseFloat((value / Math.pow(formatUnitsK, i)).toFixed(dm))} ${sizes[i]}`;
};
